export enum ServiceCallTypeEnum {
  Get,
  Post,
  Put,
  Delete,
}